import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentTitle } from 'components/DocumentTitle';
import Stepper from 'components/Stepper';
import { Heading } from 'components/Typography';
import { DailyRoutineCtx } from 'domains/dailyRoutines/context';
import { DAILY_ROUTINE_STEPPER_TITLE_IDS } from 'domains/dailyRoutines/steps';
import { useTrack } from 'utils/hooks/useMixPanel';
import PracticeOverview from 'domains/dailyRoutines/Components/PracticeOverview';
import { ContentContainer } from 'components/ContentContainer';
import { PageHeaderCard } from 'components/PageHeaderCard';
import { Icon } from 'components/Icon';
import SubmitActivity from 'domains/dailyRoutines/Components/SubmitActivity';
import { ASSIGNMENT_MIXPANEL_EVENTS } from 'domains/assignments/mixpanel';

export const DailyRoutineUI: React.FC = () => {
  useTrack(ASSIGNMENT_MIXPANEL_EVENTS.viewed.adl);
  const { t } = useTranslation();

  const { currentStep, onNavigateToStep, stepsState, learningPathContent, dailyRoutineContent } =
    useContext(DailyRoutineCtx);

  const { setting } = dailyRoutineContent;
  const { title: learningPathTitle } = learningPathContent;

  return (
    <>
      <DocumentTitle>{t('dailyRoutine.pageTitle')}</DocumentTitle>

      <ContentContainer variant="full">
        <PageHeaderCard textureVariant="yellow">
          <Heading level="h6" as="h2">
            {t('dailyRoutine.pageTitle')}
          </Heading>
          <Heading level="h2" className="text-center">
            {`${learningPathTitle} ${setting}`}
          </Heading>

          <Heading level="h5" className="font-medium flex gap-12 items-start text-left">
            <Icon name="Clock" /> <span>{t('dailyRoutine.subTitle')}</span>
          </Heading>
        </PageHeaderCard>

        <ContentContainer variant="centered-md" className="mb-64">
          <Stepper currentStep={currentStep} onNavigate={onNavigateToStep} className="my-40 sm-d:my-24 w-full">
            {Object.values(DAILY_ROUTINE_STEPPER_TITLE_IDS).map((title, index) => (
              <Stepper.Step key={title} index={index} isCompleted={stepsState[index]}>
                {t(`dailyRoutine.steps.title.${title}`)}
              </Stepper.Step>
            ))}
          </Stepper>

          <div className="flex flex-col gap-40 items-start w-full">
            <PracticeOverview />
            <SubmitActivity />
          </div>
        </ContentContainer>
      </ContentContainer>
    </>
  );
};
